import { prefix } from '../../utils/prefix';

const Url = {
  getBasicInfo: `${prefix}/info/basicInfo/get`, // 基本信息
  getPersonalInfo: `${prefix}/info/personalInfo/get`, // 个人信息
  getBankInfo: `${prefix}/info/bankInfo/get`, // 银行信息
  getEducationInfo: `${prefix}/info/educationsInfo/get`, // 教育信息
  getEducationInfoV2: `${prefix}/info/educationsInfo/v2/get`, // 教育信息v2
  getUnableReason: `${prefix}/dataset/get/unableReason`, // 获取无法上传的原因
  getWorksInfo: `${prefix}/info/worksInfo/get`, // 工作经历
  getDeclarationInfo: `${prefix}/info/declaration/get`, // 利益申报
  getHealthInfo: `${prefix}/info/healthInfo/get`, // 健康信息
  homeDetail: `${prefix}/home/detail`,
  getTaxInfo: `${prefix}/info/commitment/get`, // 银行信息
  getEntryTypeAndComputer: `${prefix}/info/getEntryTypeAndComputer`, // 获取入职类型与电脑类型
};

export default Url;
